import { classes } from '@src/components/layout/space';
import { testIdAttr } from '@src/components/testId';
import './Spinner.css';

export type SpinnerSize = 'small' | 'medium';

export interface SpinnerProps {
  size?: SpinnerSize;
  /** Announced while a region is loading. Omit inside a button — its label speaks. */
  label?: string;
  className?: string;
  testId?: string;
}

/** Busy mark. Takes its colour from the text around it. */
export function Spinner({ size = 'small', label, className, testId }: SpinnerProps) {
  return (
    <span
      className={classes('spinner', size === 'medium' && 'spinner--medium', className)}
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : 'true'}
      {...testIdAttr(testId)}
    />
  );
}
